import React from "react";
import img75 from "../../assets/img75.png";
import img76 from "../../assets/img76.png";
import { Plus, Minus, XCircle, CheckCircle, Mail } from "lucide-react";
import img77 from "../../assets/img77.png";
import img78 from "../../assets/img78.jpeg";
import img79 from "../../assets/img79.png";
import img80 from "../../assets/img80.jpeg";
import Aman from "../../assets/Aman.jpg";
import Testimonials from "../../components/Testimonials";
import SEO from "../../components/SEO";

const faqs = [
  {
    question: "Qu'est-ce que l'assurance vie ?",
    answer:
      "L'assurance vie est un contrat par lequel un assureur garantit le versement d'une prestation aux bénéficiaires au décès de l'assuré.",
  },
  {
    question: "Comment puis-je réduire le coût de l'assurance vie ?",
    answer:
      "Souscrire une assurance vie lorsque vous êtes jeune et en bonne santé, opter pour une assurance vie temporaire plutôt qu'une police permanente, adopter un mode de vie sain et comparer soigneusement différentes polices et assureurs peut aider à réduire les coûts.",
  },
  {
    question: "Contre quels risques l'assurance vie protège-t-elle ?",
    answer:
      "Il existe deux principaux risques de la vie contre lesquels des polices d'assurance vie spécifiques protègent, à savoir le risque de décès prématuré laissant une famille à charge livrée à elle-même, ainsi que le risque de vivre jusqu'à un âge avancé sans sécurité financière.",
  },
  {
    question:
      "L'assurance vie offre-t-elle un avantage pour les personnes célibataires ?",
    answer:
      "Pour les personnes célibataires, l'assurance vie est nécessaire pour couvrir toute obligation financière telle que des prêts ou des paiements de cartes de crédit en souffrance, afin que, en cas d'incident malheureux, leurs parents soient libérés de tout fardeau financier.",
  },
];

function GetStarted() {
  const [openIndex, setOpenIndex] = React.useState(0);

  return (
    <>
    <SEO
      title="Prendre rendez-vous | einsured.ca Canada"
      description="Découvrez pourquoi l’assurance-vie est importante, ses avantages, ses coûts et comment choisir une couverture adaptée à vos besoins avec einsured.ca. "
    />
    <div className="w-full overflow-x-hidden">
      <section className="bg-gradient-to-r from-[#1FB5F2] to-[#1E3E78] py-12 sm:py-14 md:py-16">
        <div className="max-w-5xl mx-auto px-6 text-center text-white">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Comment planifier une réunion
          </h1>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
            Nous sommes une équipe de courtiers d'assurance expérimentés qui comprennent que la
            situation de chaque personne est différente. Avec plus de 12 ans d'expertise
            dans le secteur de l'assurance, notre mission est de vous fournir un service
            personnalisé et les meilleures options de couverture disponibles.
          </p>
        </div>

        {/* Steps + Calendly-style widget */}
        <div className="max-w-6xl mx-auto px-4 md:px-6 mt-10 md:mt-14 pb-6 md:pb-10">
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1.2fr)] gap-8 md:gap-10 items-start">
            <div className="space-y-6 md:space-y-7">
              {/* Card 1 */}
              <div className="bg-white rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] px-6 sm:px-10 py-7 sm:py-8 text-center">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#43577A] mb-3">
                  Choisissez votre date et heure préférées
                </h2>
                <p className="text-sm sm:text-base text-[#5B667C] leading-relaxed">
                  Calendly est conçu pour votre commodité. Sélectionnez simplement la
                  date et l'heure qui vous conviennent le mieux.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] px-6 sm:px-10 py-7 sm:py-8 text-center">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#43577A] mb-3">
                  Fournissez vos coordonnées
                </h2>
                <p className="text-sm sm:text-base text-[#5B667C] leading-relaxed">
                  Remplissez un court formulaire avec vos coordonnées afin que nous puissions
                  vous contacter si nous avons besoin d'informations supplémentaires avant
                  notre réunion.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-white rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] px-6 sm:px-10 py-7 sm:py-8 text-center">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#43577A] mb-3">
                  Parlez-nous brièvement de vos besoins
                </h2>
                <p className="text-sm sm:text-base text-[#5B667C] leading-relaxed">
                  Dites-nous brièvement ce que vous recherchez. Cela nous aide à nous
                  préparer afin de tirer le meilleur parti de notre temps ensemble.
                </p>
              </div>

              {/* Card 4 */}
              <div className="bg-white rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] px-6 sm:px-10 py-7 sm:py-8 text-center">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#43577A] mb-3">
                  Confirmation
                </h2>
                <p className="text-sm sm:text-base text-[#5B667C] leading-relaxed">
                  Vous recevrez un courriel de confirmation avec les détails de
                  votre réunion, ainsi qu'une invitation de calendrier pour noter la date.
                </p>
              </div>
            </div>

          {/* RIGHT */}
<div className="bg-white rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] overflow-hidden w-full p-4 sm:p-5">
  <div className="rounded-[24px] overflow-hidden border border-gray-200 bg-white">

    <div className="relative h-[620px] sm:h-[720px] md:h-[760px] lg:h-[820px] overflow-y-auto">
      <iframe
        src="https://book.einsured.ca/widget/bookings/ei-team"
        title="einsured.ca révision de 10 minutes"
        loading="lazy"
        className="w-full border-0 h-[980px]"
      />
    </div>
  </div>
</div>




</div>


        </div>
      </section>

      {/* Why is Life insurance */}
      <section className="bg-[#F4FAFF] py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex justify-center mb-8 md:mb-10">
            <div className="inline-flex items-center justify-center px-8 sm:px-12 md:px-16 py-2.5 rounded-full bg-[#E6F1FF]">
              <h2 className="text-base sm:text-lg md:text-3xl font-semibold text-[#4B628C] text-center">
                Pourquoi l'assurance vie est-elle un choix idéal pour vous ?
              </h2>
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src={img75}
              alt="Pourquoi l'assurance vie est-elle un choix idéal pour vous ?"
              className="w-full max-w-5xl rounded-3xl shadow-[0_20px_45px_rgba(15,35,65,0.18)]"
              loading="lazy"
            />
          </div>

          {/* Family banner */}
          <div className="mt-12 sm:mt-16 md:mt-20 flex justify-center">
            <img
              src={img76}
              alt="N'oubliez pas : si vous avez une famille, vous avez besoin d'une assurance vie !"
              className="w-full max-w-5xl rounded-3xl shadow-[0_20px_45px_rgba(15,35,65,0.18)]"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Why does life insurance matter section */}
      <section className="py-12 sm:py-14 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6 space-y-10 md:space-y-12">
          <div className="flex justify-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#4B628C] text-center">
              Pourquoi l'assurance vie est-elle importante pour vous ?
            </h2>
          </div>

          {/* Before / After comparison card */}
          <div className="rounded-3xl border border-[#3F5785] overflow-hidden shadow-[0_20px_45px_rgba(15,35,65,0.18)] bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="bg-[#F4FAFF] px-6 sm:px-8 md:px-10 pb-8 pt-6 md:pt-8">
                <div className="inline-flex px-8 py-3 rounded-full bg-[#43577A] mb-6">
                  <p className="text-white font-semibold text-lg">
                    Avant l'assurance vie
                  </p>
                </div>

                <ul className="space-y-3.5 text-[#4C5E73] text-sm sm:text-base">
                  {[
                    "Sécurité financière limitée pour les personnes à charge",
                    "Planification successorale compliquée et potentiellement contraignante",
                    "Les dettes pourraient alourdir le fardeau des membres de la famille",
                    "Frais funéraires à payer de sa poche",
                    "Risque financier plus élevé en cas de décès prématuré",
                    "Plus difficile d'atteindre des objectifs financiers à long terme",
                    "Moins d'options pour des investissements diversifiés",
                    "Possibilités limitées d'économies fiscales",
                    "Aucune accumulation de valeur de rachat",
                    "Aucune planification financière personnalisée",
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="mt-0.5">
                        <XCircle className="w-4 h-4 text-[#A6B4C7]" />
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* After column */}
              <div className="bg-[#3F5785] px-6 sm:px-8 md:px-10 pb-8 pt-6 md:pt-8 text-white">
                <div className="inline-flex px-8 py-3 rounded-full bg-[#00AEEF] mb-6">
                  <p className="text-white font-semibold text-lg">
                    Après l'assurance vie
                  </p>
                </div>

                <ul className="space-y-3.5 text-sm sm:text-base">
                  {[
                    "Sécurité financière renforcée pour les personnes à charge",
                    "Planification successorale simplifiée avec des bénéficiaires clairement désignés",
                    "L'assurance peut couvrir les dettes, protégeant ainsi les proches",
                    "Les frais funéraires sont souvent couverts par l'assurance",
                    "Le risque est atténué grâce à une police d'assurance vie",
                    "Plus facile d'atteindre des objectifs financiers à long terme",
                    "Possibilité de produits d'assurance liés à des investissements",
                    "Avantages fiscaux potentiels selon la police",
                    "Accumulation possible de valeur de rachat dans certaines polices",
                    "Les polices peuvent être adaptées aux besoins individuels",
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="mt-0.5">
                        <CheckCircle className="w-4 h-4 text-white" />
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Is life insurance expensive? */}
          <div className="rounded-3xl border-2 border-[#3F5785] overflow-hidden shadow-[0_20px_45px_rgba(15,35,65,0.18)] bg-[#FBF9F4]">
            <div className="h-[230px] sm:h-[260px] md:h-[280px]">
              <img
                src={img77}
                alt="L'assurance vie est-elle coûteuse ? Économisez jusqu'à 24 % sur vos primes d'assurance vie"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Life insurance is versatile */}
      <section className="bg-white py-12 sm:py-14 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex justify-center mb-10 md:mb-12">
            <div className="inline-flex items-center justify-center px-8 sm:px-12 md:px-16 py-3 rounded-full bg-[#43577A]">
              <h2 className="text-base sm:text-lg md:text-2xl font-semibold text-white text-center">
                L'assurance vie est polyvalente, vous pouvez l'utiliser pour :
              </h2>
            </div>
          </div>

          {/* 5-column uses list */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8 text-[#41516A]">
            {/* 1. Collateral for Loans */}
            <div className="rounded-3xl px-6 py-6 md:px-7 md:py-7 bg-white hover:bg-[#F4F7FD] border border-transparent hover:border-[#D5E3F7] shadow-sm hover:shadow-[0_10px_25px_rgba(15,35,65,0.15)] transition-all duration-300">
              <h3 className="text-xl md:text-2xl font-semibold text-[#43577A] mb-4 leading-snug">
                Garantie pour
                <br /> les prêts
              </h3>
              <p className="text-sm sm:text-base leading-relaxed">
                Vous avez besoin d'un prêt pour un projet d'entreprise, l'achat d'une maison ou des études supérieures ?
              </p>
              <p className="text-sm sm:text-base leading-relaxed mt-3">
                Votre police d'assurance vie peut servir de garantie. Les prêteurs y voient un moyen garanti de récupérer leur argent, ce qui peut faciliter l'obtention de votre prêt.
              </p>
            </div>

            {/* 2. Supplementing Retirement Income */}
            <div className="rounded-3xl px-6 py-6 md:px-7 md:py-7 bg-white hover:bg-[#F4F7FD] border border-transparent hover:border-[#D5E3F7] shadow-sm hover:shadow-[0_10px_25px_rgba(15,35,65,0.15)] transition-all duration-300">
              <h3 className="text-xl md:text-2xl font-semibold text-[#43577A] mb-4 leading-snug">
                Complément de
                <br /> revenu de
                <br /> retraite
              </h3>
              <p className="text-sm sm:text-base leading-relaxed">
                Les polices d'assurance vie entière accumulent une valeur de rachat, ce qui peut constituer un excellent complément à votre Régime de rentes du Québec (RRQ) ou au Régime de pensions du Canada (RPC), vous permettant de maintenir votre style de vie même après votre retraite.
              </p>
            </div>

            {/* 3. Emergency Cash Flow */}
            <div className="rounded-3xl px-6 py-6 md:px-7 md:py-7 bg-white hover:bg-[#F4F7FD] border border-transparent hover:border-[#D5E3F7] shadow-sm hover:shadow-[0_10px_25px_rgba(15,35,65,0.15)] transition-all duration-300">
              <h3 className="text-xl md:text-2xl font-semibold text-[#43577A] mb-4 leading-snug">
                Liquidités
                <br /> d'urgence
              </h3>
              <p className="text-sm sm:text-base leading-relaxed">
                En cas d'urgence, vous pouvez emprunter sur la valeur de rachat accumulée dans les polices à des taux d'intérêt relativement bas, vous offrant ainsi un coussin financier bien nécessaire.
              </p>
            </div>

            {/* 4. Business Continuity */}
            <div className="rounded-3xl px-6 py-6 md:px-7 md:py-7 bg-white hover:bg-[#F4F7FD] border border-transparent hover:border-[#D5E3F7] shadow-sm hover:shadow-[0_10px_25px_rgba(15,35,65,0.15)] transition-all duration-300">
              <h3 className="text-xl md:text-2xl font-semibold text-[#43577A] mb-4 leading-snug">
                Continuité
                <br /> des affaires
              </h3>
              <p className="text-sm sm:text-base leading-relaxed">
                Utilisez votre police pour financer des conventions d'achat-vente, une assurance homme-clé, ou encore comme coussin financier en période difficile.
              </p>
            </div>

            {/* 5. Educational Funding */}
            <div className="rounded-3xl px-6 py-6 md:px-7 md:py-7 bg-white hover:bg-[#F4F7FD] border border-transparent hover:border-[#D5E3F7] shadow-sm hover:shadow-[0_10px_25px_rgba(15,35,65,0.15)] transition-all duration-300">
              <h3 className="text-xl md:text-2xl font-semibold text-[#43577A] mb-4 leading-snug">
                Financement
                <br /> des études
              </h3>
              <p className="text-sm sm:text-base leading-relaxed">
                Envisagez d'exploiter la valeur de rachat de votre police pour financer les études de vos enfants. C'est une voie moins conventionnelle, mais le meilleur départ possible dans la vie sans recourir à des prêts étudiants à taux élevé.
              </p>
            </div>
          </div>

          {/* Bottom family image */}
          <div className="mt-10 sm:mt-6 md:mt-2 flex justify-center">
            <div className="w-full max-w-5xl overflow-hidden">
              <img
                src={img78}
                alt="Famille discutant des options d'assurance vie"
                className="w-full object-cover translate-y-[-40px] sm:translate-y-[-60px] md:translate-y-[-80px]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Frequently Asked Questions */}
      <section className="bg-white py-12 sm:py-14 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#43577A] text-center mb-8 md:mb-10">
            Questions fréquemment posées
          </h2>

          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={index}
                  className="border border-[#E1E7F0] bg-white rounded-lg"
                >
                  {/* Question row */}
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center justify-between px-5 sm:px-6 py-4 sm:py-5 text-left"
                  >
                    <span className="text-sm sm:text-base md:text-lg font-semibold text-[#365886]">
                      {item.question}
                    </span>

                    <span className="ml-4 flex-shrink-0">
                      {isOpen ? (
                        <Minus
                          className="w-5 h-5 text-[#21A9F5]"
                          strokeWidth={2.5}
                        />
                      ) : (
                        <Plus
                          className="w-5 h-5 text-[#21A9F5]"
                          strokeWidth={2.5}
                        />
                      )}
                    </span>
                  </button>

                  {/* Answer */}
                  {isOpen && (
                    <div className="border-t border-[#E1E7F0] px-5 sm:px-6 py-4 sm:py-5 bg-[#F9FBFF]">
                      <p className="text-sm sm:text-base text-[#4E5F76] leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* What do we do for you */}
      <section className="bg-[#F4FAFF] py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6 flex justify-center">
          <img
            src={img79}
            alt="Que faisons-nous pour vous ?"
            className="w-full max-w-5xl rounded-[32px] shadow-[0_18px_40px_rgba(0,0,0,0.08)]"
            loading="lazy"
          />
        </div>
      </section>
      <Testimonials limit={9} autoPlay={true} intervalMs={4500} />

      {/* Take your time to review */}
      <section className="bg-[#F4FAFF] py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] rounded-[32px] overflow-hidden shadow-[0_20px_45px_rgba(15,35,65,0.18)] bg-gradient-to-r from-[#355784] via-[#3D5F8D] to-[#F4FAFF]">

            {/* Left: text content */}
            <div className="px-8 sm:px-10 md:px-12 py-8 md:py-12 flex flex-col justify-center text-white">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-5">
                Prenez le temps de réfléchir !
              </h2>

              <p className="text-sm sm:text-base md:text-lg leading-relaxed mb-4">
                Nous comprenons que souscrire une assurance vie est une grande décision.
                C'est pourquoi nous offrons une consultation gratuite avec nos conseillers experts.
                Ils vous aideront à comprendre vos options et à trouver le meilleur plan
                pour vous. Sans engagement ni frais cachés — juste des informations utiles
                pour guider votre choix.
              </p>

              <p className="text-sm sm:text-base md:text-lg leading-relaxed">
                Protégez l'avenir de votre famille dès aujourd'hui. Contactez-nous pour planifier votre
                consultation gratuite et découvrir la tranquillité d'esprit qu'apporte
                l'assurance vie.
              </p>

              <div className="mt-6">
                <a
                  href="/fr/prendre-rendez-vous"
                  className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#1FB5F2] hover:bg-[#12A0D8] text-white font-semibold text-sm sm:text-base shadow-md transition-colors duration-300"
                >
                  Nous contacter

                  <Mail className="w-4 h-4 ml-2" />
                </a>
              </div>
            </div>

            {/* Right image */}
            <div className="h-64 md:h-full">
              <img
                src={img80}
                alt="Famille révisant ensemble leurs options d'assurance vie"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Senior Financial Advisor */}
      <section className="py-12 sm:py-14 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="rounded-[32px] bg-[#10A0DE] text-white shadow-[0_24px_60px_rgba(9,32,74,0.25)] overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_minmax(0,1fr)]">
              {/* Text side */}
              <div className="px-6 sm:px-10 md:px-12 py-8 md:py-10 lg:py-12">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4 md:mb-6">
                  Un message de notre conseiller
                  <br className="hidden sm:block" /> financier principal
                </h2>

                <div className="space-y-3 sm:space-y-3.5 text-sm sm:text-base leading-relaxed md:leading-relaxed">
                  <p>
                    Bonjour et bienvenue,
                  </p>
                  <p>
                    Je suis ravi que vous soyez ici, en train de faire le premier pas vers
                    la sécurité de votre avenir financier. C'est non seulement un signe de
                    prévoyance, mais aussi de sagesse. Je m'appelle Aman Ahuja, et j'accompagne
                    des particuliers et des familles comme la vôtre depuis plus de 14 ans dans
                    le secteur canadien de l'assurance.
                  </p>
                  <p>
                    Naviguer dans le monde de l'assurance peut ressembler à trouver son chemin
                    dans un labyrinthe complexe. C'est là que nous intervenons.
                    Chez einsured.ca, nous n'offrons pas seulement de l'assurance ; nous offrons
                    la tranquillité d'esprit, un filet de sécurité, et la promesse que nous sommes
                    là pour vous, quoi que la vie vous réserve.
                  </p>
                  <p>
                    L'assurance n'est pas universelle. Votre vie, vos rêves
                    et vos préoccupations sont uniques. C'est pourquoi nous croyons en la
                    création de solutions d'assurance personnalisées qui s'adaptent parfaitement à vous.
                  </p>
                  <p className="font-bold mt-3">
                    Pourquoi nous faire confiance ?
                  </p>
                  <p>
                    Avec une vaste expérience et un engagement envers l'excellence, nous
                    plaçons vos besoins au-dessus de tout. Nous ne sommes pas là pour vous
                    vendre quelque chose ; nous sommes là pour nous associer à vous, comprendre
                    vos objectifs et vous aider à les atteindre.
                  </p>
                  <p>
                    Cordialement,
                    <br />
                    <span className="font-bold">Aman Ahuja</span>
                    <br />
                    Conseiller financier principal, einsured.ca
                  </p>
                </div>
              </div>

              {/* Image side */}
              <div className="flex items-stretch justify-center mt-8 lg:mt-0">
                <div className="w-full h-full flex items-center justify-center px-4 py-6 md:px-6 md:py-8">
                  <img
                    src={Aman}
                    alt="Aman Ahuja, conseiller financier principal"
                    className="h-full max-h-[520px] w-auto object-cover rounded-3xl lg:rounded-[28px]"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
    </>
  );
}

export default GetStarted;
